import { Box } from "@chakra-ui/react";

import { useSelector } from "react-redux";

import { getReportDescription } from "../../store/helpers";
import ArrivalRatesByServiceReport from "../../components/organization/reports/ArrivalRatesByService";
import _ from "lodash";
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const ArrivalRatesPerService = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const { data } = reportsData;

  const title = `${reportIndex}. Arrival Rates Per Service`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
  });

  return (
    <Box>
      <h1>{title}</h1>
      <p>{getReportDescription(reportRange).ArrivalRatesByService}</p>
      {presentationSummaryItems.length ? (
        <div className="reportPresentationSummary">
          <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
        </div>
      ) : null}
      {!_.isEmpty(data) ? (
        <>
          <Box mt={10}>
            <ArrivalRatesByServiceReport
              reportIndex={reportIndex}
              data={data}
            />
          </Box>
        </>
      ) : (
        <Box mt={10}>
          <p>No data available in this search</p>
        </Box>
      )}
    </Box>
  );
};

export default ArrivalRatesPerService;
